import { type TokenInfo, tokens } from '@/config/tokens';
import { Avatar, Box, Button, Group, Menu, NumberInput, ScrollArea, Text } from '@mantine/core';
import { useState } from 'react';
import { Icons } from '../Shares/Icons';
import classes from './Wallet.module.css';
export const SelectTokenMenu: React.FC = () => {
  const [token, setToken] = useState<TokenInfo>(tokens[0]);
  const [menuIsOpen, setMenuIsOpen] = useState<boolean>(false);
  return <NumberInput size="md" flex={1} w="100%" thousandSeparator="," decimalSeparator="." decimalScale={9} rightSectionWidth={100} classNames={{
    input: classes.input
  }} style={{
    zIndex: 200
  }} rightSection={<Menu shadow="md" width={320} withinPortal={false} position="bottom-end" classNames={classes} onChange={() => setMenuIsOpen(!menuIsOpen)}>
          <Menu.Target>
            <Button px={0} variant="transparent" style={{
        pointerEvents: 'auto'
      }} classNames={{
        section: classes.section
      }} rightSection={<Box mod={{
        active: menuIsOpen
      }} className={classes.iconStyle}>
                  <Icons className="icon-pr-line-chevron-down" fontSize={24} />
                </Box>}>
              <Group gap={4}>
                <Avatar src={token.logoURI} size={24} variant="transparent" />
                <Text fz={13} c="var(--text-dark)">
                  {token.symbol}
                </Text>
              </Group>
            </Button>
          </Menu.Target>

          <Menu.Dropdown style={{
      pointerEvents: 'auto'
    }}>
            <ScrollArea h={280} offsetScrollbars classNames={classes}>
              {tokens.map(item => <Menu.Item key={item.symbol} mod={{
          active: item.symbol === token.symbol
        }} leftSection={<Avatar variant="transparent" src={item.logoURI} size={24} />} onClick={() => setToken(item)}>
                  <Text fz="xs" tt="uppercase" fw={700}>
                    {`${item.name} (${item.symbol})`}
                  </Text>
                </Menu.Item>)}
            </ScrollArea>
          </Menu.Dropdown>
        </Menu>} />;
};